<template>
  <v-autocomplete
    v-model="selectedSchool"
    :items="filteredSchools"
    :item-text="(item) => `${item.schoolName} - ${item.dbn}`"
    return-object
    @change="selectItem"
    placeholder="Start typing school name or DBN"
    clearable
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.schoolName }}</v-list-item-title>
        <v-list-item-subtitle> {{ item.streetAddress }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:no-data
      ><v-card
        flat
        dense
        color="grey lighten-2"
        @click="goToNewSchool"
        text
        class="text-center text-decoration-underline"
        ><v-card-text
          ><v-btn small>Create New School</v-btn></v-card-text
        ></v-card
      >
    </template>
  </v-autocomplete>
</template>


<script>
export default {
  props: ["school", "isSummerSemester", "clientId"],
  data() {
    return {
      selectedSchool: this.school,
    };
  },
  computed: {
    filteredSchools() {
      if (this.isSummerSemester != null) {
        return this.$store.getters[
          "optionsModule/getFilteredSchoolsByIsSummerCamp"
        ](this.isSummerSemester ?? false);
      } else {
        return this.$store.state.optionsModule.schools;
      }
    },
  },
  methods: {
    selectItem() {
      this.$emit("selectSchool", this.selectedSchool?.schoolId);
    },
    goToNewSchool() {
      this.$router.push({
        name: "NewSchool",
        params: { clientId: this.clientId },
      });
    },
  },
};
</script>